import { render, staticRenderFns } from "./activityInfo.vue?vue&type=template&id=fffcf20c&scoped=true&"
import script from "./activityInfo.vue?vue&type=script&lang=js&"
export * from "./activityInfo.vue?vue&type=script&lang=js&"
import style0 from "./activityInfo.vue?vue&type=style&index=0&id=fffcf20c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fffcf20c",
  null
  
)

export default component.exports